module.exports = __webpack_public_path__ + "static/media/banner-login-lado-bom-seguros.e2370a21.png";